import { useTranslation } from "react-i18next";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import FrequentSelect from "../FrequentSelect";
import { BIKE_TYPES } from "../../../lib/listingConstants";

/**
 * BicycleDetailsSection — Fahrrad-spezifische Felder (Rahmen, Schaltung, Größe).
 * Nur sichtbar für `category=bicycle`. Aus CreateListingPage extrahiert (Phase 4.6).
 */
export default function BicycleDetailsSection({ form, update, isMoto }) {
    const { t } = useTranslation();
    if (isMoto) return null;
    return (
        <div className="bg-white border border-gray-200 rounded-sm p-6 grid grid-cols-1 md:grid-cols-2 gap-4">
            <h2 className="md:col-span-2 font-display text-lg font-bold">{t("create_listing.bicycle_details")}</h2>
            <div>
                <Label className="text-xs font-bold uppercase text-gray-500">{t("create_listing.bike_type")}</Label>
                <FrequentSelect
                    storageKey="listing.bike_type"
                    value={form.bike_type}
                    onValueChange={(v) => update("bike_type", v)}
                    options={BIKE_TYPES}
                    placeholder={t("create_listing.bike_type_placeholder")}
                    triggerClassName="mt-1.5 rounded-sm"
                    testId="form-bike-type"
                />
            </div>
            <div><Label className="text-xs font-bold uppercase text-gray-500">{t("create_listing.frame_material")}</Label><Input value={form.frame_material} onChange={(e) => update("frame_material", e.target.value)} placeholder={t("create_listing.frame_material_placeholder")} className="mt-1.5 rounded-sm" /></div>
            <div><Label className="text-xs font-bold uppercase text-gray-500">{t("create_listing.frame_size")}</Label><Input value={form.frame_size} onChange={(e) => update("frame_size", e.target.value)} placeholder={t("create_listing.frame_size_placeholder")} className="mt-1.5 rounded-sm" /></div>
            <div><Label className="text-xs font-bold uppercase text-gray-500">{t("create_listing.wheel_size")}</Label><Input value={form.wheel_size} onChange={(e) => update("wheel_size", e.target.value)} placeholder={t("create_listing.wheel_size_placeholder")} className="mt-1.5 rounded-sm" /></div>
            <div><Label className="text-xs font-bold uppercase text-gray-500">{t("create_listing.gears")}</Label><Input type="number" value={form.gears} onChange={(e) => update("gears", e.target.value)} className="mt-1.5 rounded-sm" /></div>
        </div>
    );
}
